import {availableCountries, getCountryCode} from './CountryRestrictionUtility';

/**
 * @author Johannes Sommer <j.sommer@andersundsehr.com>
 */
export class CountryRestrictionController {
  private readonly country: string = '';

  public constructor() {
    const countryRestrictedElements = document.querySelectorAll('.js-countryLimitation');
    if (countryRestrictedElements.length > 0) {
      this.country = getCountryCode();
      for (let i = 0; i < countryRestrictedElements.length; i++) {
        this.applyRestrictionForElement(<HTMLElement>countryRestrictedElements[i]);
      }
    }
  }

  protected applyRestrictionForElement(element: HTMLElement): void {
    const countryArray = (element.dataset.countrylimitation || '').split(',');

    if (element.classList.contains('js-restrictedContentElement')) {
      this.showRestrictedElement(element, countryArray);
    } else {
      // Legacy function
      this.hideRestrictedElement(element, countryArray);
    }
  }

  private showRestrictedElement(element: HTMLElement, countryArray: string[]): void {
    if ((countryArray.includes('others') && !availableCountries.includes(this.country))
      || countryArray.includes(this.country)) {
      element.outerHTML = element.innerHTML
        .replace('<!--restrictionreplacement', '')
        .replace('-->', '')
        .replace('--A>', '-->')
        .replace('--A2>', '--A>')
        .replace('--A3>', '--A2>')
        .replace('--A4>', '--A3>')
        .replace('--A5>', '--A4>');
    } else {
      // remove element from dom because of styling problems (class noWhiteSpaceAfter -> FAU-1081)
      element.remove();
    }
  }

  /**
   * Legacy function for single use cases (e.g. one navigation point)
   */
  private hideRestrictedElement(element: HTMLElement, countryArray: string[]): void {
    if ((countryArray.includes('others') && availableCountries.includes(this.country))
      || !countryArray.includes(this.country)) {
      element.classList.add('hide');
    }
  }
}
